import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-16',
  templateUrl: './16.component.html',
  styleUrls: ['./16.component.scss'],
})
export class VbList16Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
